import { JsonEditor } from "@/components/JsonEditor"
import { FieldLabel } from "@/components/shared/forms/FieldLabel"

interface CustomSipHeadersFieldProps {
  /** Parsed object form of the current custom SIP headers. */
  value: Record<string, unknown>
  /** Receives the serialized JSON string when the editor changes. */
  onChange: (json: string) => void
}

/**
 * Custom SIP headers editor used by the inbound-voice field groups. Renders the
 * labeled JSON editor plus the explanatory tooltip describing how each
 * key-value pair maps to an outgoing SIP INVITE header.
 */
export const CustomSipHeadersField: React.FC<CustomSipHeadersFieldProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="space-y-2">
      <FieldLabel
        tooltip={
          <div className="max-w-xs p-1 text-xs leading-relaxed">
            <p>
              Each key-value pair is sent as an individual SIP header on the
              outgoing INVITE request. Values support{" "}
              {"{{simulation_output_id}}"} (alias: {"{{simulation_id}}"}),{" "}
              {"{{test_case.*}}"}, {"{{agent.*}}"}, {"{{run_metadata.*}}"}, and{" "}
              {"{{sim_wrapper.*}}"} template variables.
            </p>
            <p className="mt-1.5 font-medium">Example headers sent:</p>
            <pre className="mt-1 rounded bg-surface-1 p-1.5 text-[11px] leading-snug">
              {`X-Session-Id: abc-123
X-Coval-Simulation-Id: <auto>`}
            </pre>
            <p className="mt-1.5 text-coval-text-muted">
              X-Coval-Simulation-Id is always included automatically.
            </p>
          </div>
        }
      >
        Custom SIP Headers
      </FieldLabel>
      <JsonEditor
        hideGutters
        copyable
        value={value}
        onChange={(val) => onChange(JSON.stringify(val))}
        height="150px"
        allowEmpty
        ariaLabel="Custom SIP headers JSON"
      />
    </div>
  )
}
